module.exports = __webpack_public_path__ + "static/media/thermometer-quarter.a26fc70c.svg";